/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RegisterAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function RegisterAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Add/Content/RegisterAction",
  onSubmit,
  isSubmitting
  
}) {
let newReferralSubmitData = fromData.useDataSubmit({ viewPath,
context: 'new_referral',
})
let newReferralIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'new_referral',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 block={true}
 data="new_referral"
 onClick={newReferralSubmitData}
 disabled={newReferralIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Add Referral"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}